import { BaseUnits } from "uom";
import * as UnitDivide from "../unit-divide";
import { Volt } from "./electric-potential";
/**
 * The derived unit for electric conductance ( <code>S</code> ).
 * One Siemens is equal to one ampere per volt.
 * It is named after the German engineer Ernst Werner von Siemens (1816-1892).
 */
export var Siemens = UnitDivide.electricalCurrentByElectricalPotential("Siemens", BaseUnits.Ampere, Volt);
//# sourceMappingURL=electric-conductance.js.map